import * as types from './types';
import { getErrorMessage } from 'utils';
import { uiActions } from 'state/modules/UI';
import * as telemetryActions from 'services/api/telemetry';

const fetchTelemetryRequest = () => ({
  type: types.FETCH_TELEMETRY_REQUEST,
});

const fetchTelemetrySuccess = (payload) => ({
  type: types.FETCH_TELEMETRY_SUCCESS,
  payload,
});

const fetchTelemetryFailed = () => ({
  type: types.FETCH_TELEMETRY_FAILED,
});

export const fetchTelemetry = (id, params = {}) => {
  return async (dispatch) => {
    dispatch(fetchTelemetryRequest());

    const response = await telemetryActions.fetchTelemetry(id, params);

    if (response.ok) {
      return dispatch(fetchTelemetrySuccess(response.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchTelemetryFailed());
  };
};

const fetchUpdateTelemetryRequest = () => ({
  type: types.FETCH_UPDATE_TELEMETRY_REQUEST,
});

const fetchUpdateTelemetrySuccess = (payload) => ({
  type: types.FETCH_UPDATE_TELEMETRY_SUCCESS,
  payload,
});

const fetchUpdateTelemetryFailed = () => ({
  type: types.FETCH_UPDATE_TELEMETRY_FAILED,
});

export const fetchUpdateTelemetry = (id, params = {}) => {
  return async (dispatch) => {
    dispatch(fetchUpdateTelemetryRequest());

    const response = await telemetryActions.fetchUpdateTelemetry(id, params);

    if (response.ok) {
      return dispatch(fetchUpdateTelemetrySuccess(response.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchUpdateTelemetryFailed());
  };
};

export const resetUpdateTelemetry = () => (dispatch) => {
  return dispatch({
    type: types.FETCH_RESET_UPDATE_TELEMETRY_FAILED,
  });
};
